<template>
  <AppDialog
    :is-open="isDialogOpened"
    :ok-loading="deleteSubscriptionTeamPending"
    :cancel-disabled="deleteSubscriptionTeamPending"
    :ok-text="$t('subscriptions.views.SubscriptionTeams.deleteTeam')"
    @ok="deleteSubscriptionTeam"
    @cancel="closeDialog"
  >
    <template #title>
      {{ $t('subscriptions.views.SubscriptionTeams.deleteTeamDialogTitle', { teamName: subscriptionTeam.name }) }}
    </template>
    <template #body>
      <p>{{ $t('subscriptions.views.SubscriptionTeams.deleteTeamDialogText') }}</p>
    </template>
  </AppDialog>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  import AppDialog from '@/common/dialogs/AppDialog.vue'
  import { toast } from '@/common/utils/toast'
  import { dialogMixin } from '@/mixins/dialogMixin'
  import { DELETE_SUBSCRIPTION_TEAM } from '@/store/modules/subscription/action_types'

  export default {
    name: 'SubscriptionTeamsDeleteDialog',
    components: { AppDialog },
    mixins: [dialogMixin],
    props: {
      subscriptionTeam: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState('subscription', ['deleteSubscriptionTeamPending']),
    },
    methods: {
      ...mapActions('subscription', [DELETE_SUBSCRIPTION_TEAM]),
      async deleteSubscriptionTeam () {
        try {
          await this.DELETE_SUBSCRIPTION_TEAM(this.subscriptionTeam.id)
          toast.success(this.$t('subscriptions.views.SubscriptionTeams.deleteTeamSuccess', { teamName: this.subscriptionTeam.name }))
          this.closeDialog()
          this.$emit('delete-success', this.subscriptionTeam)
        } catch (error) {
          toast.error(this.$t('common.msgFailErrorOccurred'))
        }
      },
    },
  }
</script>
